.page {
  padding: 12px var(--pad) 0;
}

.stack > * + * {
  margin-top: var(--gap);
}

.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 70vh;
  padding: 32px;
  text-align: center;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.text {
  max-width: 280px;
  font-size: 15px;
  color: var(--muted);
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid var(--line);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Уважаем системную настройку: непрерывное вращение — частый триггер
   для тех, кто отключил анимации. */
@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 2.4s;
  }
}
